export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于本站</h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">了解51cg网址导航的定位与使命</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/60 p-6 md:p-10">
            <div className="max-w-none">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                51cg网址导航是一个专注于51cg平台的第三方信息聚合与网址导航站点。我们的目标是为用户提供最及时、最准确的51cg官方域名入口信息，帮助大家快速、安全地访问51cg平台。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                本站持续追踪51cg域名变更动态，整合平台功能介绍、使用指南、安全提醒等实用信息。无论您是51cg的长期用户还是新访客，都可以通过本站快速了解51cg是什么、51cg.fun是什么，并找到可用的51cg官方网站入口。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                我们坚持信息透明、更新及时的原则，所有域名信息均经过多重验证确认可用后才予收录。本站为非官方站点，所有内容仅供参考，不涉及平台运营。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}